"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var ReactImageCrop = require("react-image-crop/dist/ReactCrop");
var classNames = require("classnames");
var I18n = require("i18n-js");
var Editor = /** @class */ (function (_super) {
    tslib_1.__extends(Editor, _super);
    function Editor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isCropping: false,
            photo: _this.props.photo,
        };
        return _this;
    }
    Editor.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.photo !== this.props.photo) {
            this.state = {
                isCropping: false,
                photo: nextProps.photo,
            };
        }
    };
    Editor.prototype.handleCropChange = function (crop) {
        var newCrop = tslib_1.__assign(tslib_1.__assign({}, crop), { aspect: 1 });
        this.setState({ crop: newCrop });
    };
    Editor.prototype.handleImageDoneLoading = function () {
        this.setState({ isLoadingPhoto: false });
    };
    Editor.prototype.startCrop = function () {
        var initialCrop = this.state.photo.crop;
        if (!initialCrop.width) {
            initialCrop = { width: 100, aspect: 1 };
        }
        this.setState({
            isCropping: true,
            crop: initialCrop,
            initialCrop: initialCrop,
        });
    };
    Editor.prototype.cancelCrop = function () {
        this.setState({
            isCropping: false,
            crop: this.state.initialCrop,
        });
    };
    Editor.prototype.saveCrop = function (callback) {
        var newPhoto = this.state.photo.copy();
        newPhoto.crop = this.state.crop;
        this.setState({ isCropping: false, photo: newPhoto }, callback);
    };
    Editor.prototype.rotate = function () {
        var newPhoto = this.state.photo.copy();
        newPhoto.rotate();
        this.setState({ photo: newPhoto, isLoadingPhoto: true });
    };
    Editor.prototype.savePhoto = function () {
        var _this = this;
        if (this.state.isCropping) {
            this.saveCrop(function () {
                _this.props.onUpdatePhoto(_this.state.photo);
            });
        }
        else {
            this.props.onUpdatePhoto(this.state.photo);
        }
    };
    Editor.prototype.closeEditor = function () {
        this.props.onCloseEditor();
    };
    Editor.prototype.renderInitialState = function () {
        var _this = this;
        var imgBackgroundClassNames = classNames('img-editor__img-background', { 'img-editor__img-background--loading': this.state.isLoadingPhoto });
        return (React.createElement("div", null,
            React.createElement("div", { className: imgBackgroundClassNames },
                React.createElement("img", { src: this.state.photo.fullUrl, className: "img-editor__preview-image", role: "presentation", onLoad: function () { return _this.handleImageDoneLoading(); } })),
            React.createElement("div", { className: "img-editor__edit-actions" },
                React.createElement("a", { className: "img-editor__edit-action img-editor__edit-action--rotate", onClick: function () { return _this.rotate(); } }),
                React.createElement("a", { className: "img-editor__edit-action img-editor__edit-action--crop", onClick: function () { return _this.startCrop(); } }, I18n.t('discovery.photos.editor.cropToSquare')))));
    };
    Editor.prototype.renderCroppingState = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: "img-editor__img-background" },
                React.createElement(ReactImageCrop, { src: this.state.photo.fullUrlWithoutCrop, crop: this.state.crop, onChange: function (crop) { return _this.handleCropChange(crop); }, onImageLoaded: function (crop) { return _this.handleCropChange(crop); }, keepSelection: true })),
            React.createElement("div", { className: "img-editor__edit-actions" },
                React.createElement("a", { className: "img-editor__edit-action img-editor__edit-action--cancel", onClick: function () { return _this.cancelCrop(); } }, I18n.t('discovery.photos.editor.cancel')),
                React.createElement("a", { className: "img-editor__edit-action img-editor__edit-action--done", onClick: function () { return _this.saveCrop(); } }, I18n.t('discovery.photos.editor.done')))));
    };
    Editor.prototype.renderControls = function () {
        if (this.state.isCropping) {
            return this.renderCroppingState();
        }
        return this.renderInitialState();
    };
    Editor.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "img-editor" },
            React.createElement("div", { className: "img-editor__editor-frame" }, this.renderControls()),
            React.createElement("div", { className: "img-editor__actions" },
                React.createElement("a", { className: "img-editor__action img-editor__action--close", onClick: function () { return _this.closeEditor(); } }, I18n.t('discovery.photos.editor.cancel')),
                React.createElement("a", { className: "img-editor__action img-editor__action--save", onClick: function () { return _this.savePhoto(); } }, I18n.t('discovery.photos.editor.save')))));
    };
    return Editor;
}(React.Component));
Editor.propTypes = {
    photo: PropTypes.object.isRequired,
    onUpdatePhoto: PropTypes.func.isRequired,
    onCloseEditor: PropTypes.func.isRequired,
};
exports.default = Editor;
//# sourceMappingURL=editor.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/photos/editor.js
// module id = hsHn
// module chunks = 20 21